export default __webpack_public_path__ + "static/media/UiUx.e637ebe6.svg";